import React from "react"
import {
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogOverlay,
  Stack,
  Button,
  Flex,
  HStack,
  Icon,
  Link,
} from "@chakra-ui/react"

import CircleQuestion from "ui/components/icons/CircleQuestion"
import { EXTERNAL_ROUTES } from "common/constants/routes"

function TallyFeeInformationModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const cancelRef = React.useRef(null)

  return (
    <AlertDialog
      closeOnOverlayClick={false}
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader borderBottomWidth="1px" fontSize="lg" pt={5}>
            <HStack>
              <Icon as={CircleQuestion} fill="gray.500" h={5} w={5} />
              <Text>Tally Fee</Text>
            </HStack>
          </AlertDialogHeader>

          <AlertDialogCloseButton mt={2} />
          <AlertDialogBody py={4}>
            <Stack spacing={2}>
              <Flex justify="space-between">
                <Text textStyle="body.regular.lg">
                  Tally fees help us work towards a sustainable product that
                  will continue supporting decentralized internet protocols for
                  years to come.
                </Text>
              </Flex>
              <Flex justify="space-between">
                <Text textStyle="body.regular.lg">
                  To upgrade to a plan with a lower fee tier, contact sales.
                </Text>
              </Flex>
              <Link isExternal href={EXTERNAL_ROUTES.tally.docs.tallyFees()}>
                <Text textDecoration="underline" textStyle="body.regular.lg">
                  Learn more in the docs
                </Text>
              </Link>
              <Flex />
              <Button variant="tertiary" onClick={onClose}>
                Got it
              </Button>
            </Stack>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default TallyFeeInformationModal
